import { gql } from '@apollo/client';

import { Order } from '@rebound/shared-models/order/order.model';
import { Return } from '@rebound/shared-models/return/return.model';

export const OrderFragment = gql`
  fragment OrderFields on Order {
    id
    orderReference
    orderDate
    clientOrderCreatedDate
    contactName
    companyName
    addr1
    addr2
    addr3
    city
    zip
    state
    country
    phone
    email
    currencyCode
    rma
    exportAwb
    exportCarrierName
    items {
      skuCode
      skuDesc
      quantity
      price
      costPrice
      weight
      weightUom
      length
      width
      height
      dimensionsUom
      hsCode
      countryCode
      imgPath
      dangerousGoods
      exportDate
      exportAwb
      exportCarrierName
      skuUrl
      nonReturnable
      cycleonId
      colour
      size
      returned
      returnType
      exchangeItemSku
      clientMetadata
      deliveryDate
      storeCreditRefund {
        amount
        currency
      }
    }
    returns
  }
`;

export const ReturnFragment = gql`
  fragment ReturnFields on Return {
    id
    orderReference
    dateAdded
    name
    companyName
    zip
    email
    addr1
    addr2
    addr3
    city
    state
    country
    phone
    displayId
    externalId
    finalDestAddr1
    finalDestAddr2
    finalDestAddr3
    finalDestCity
    finalDestCountry
    finalDestState
    finalDestZip
    finalDestName
    finalDestCompanyName
    finalDestId
    tracking
    trackingLastUpdate
    currentTrackingStatus
    verificationEntity
    barcodeNumber
    carrier
    label
    items {
      skuCode
      skuDesc
      quantity
      price
      costPrice
      weight
      weightUom
      length
      width
      height
      dimensionsUom
      hsCode
      countryCode
      imgPath
      dangerousGoods
      tracking
      exportDate
      exportAwb
      exportCarrierName
      skuUrl
      nonReturnable
      daysForReturn
      finalDestName
      finalDestCompanyName
      finalDestId
      finalDestCountry
      finalDestState
      finalDestZip
      finalDestCity
      finalDestAddr1
      finalDestAddr2
      finalDestAddr3
      finalDestNeighborhood
      finalDestSuburb
      verificationEntity
      finalDisposition
      clientMetadata
      reason {
        action
        reason
        wish
        additional {
          title
          value
        }
      }
      returnType
      exchangeItemSku
      storeCreditRefund {
        amount
        currency
      }
    }
    trackingHistory {
      date
      status
      location {
        country
        state
        city
      }
    }
    labelType
    carrierName
    currencyCode
    refundValue
    status
  }
`;

export const ListOrdersQuery = gql`
  query listOrders {
    listOrders {
      ...OrderFields
    }
  }

  ${OrderFragment}
`;

export type ListOrdersQueryResult = {
  listOrders: Order[];
};

export const ListReturnsQuery = gql`
  query listReturns {
    listReturns {
      ...ReturnFields
    }
  }
  ${ReturnFragment}
`;

export type ListReturnsQueryResult = {
  listReturns: Return[];
};

export const OrderLookupQuery = gql`
  query orderLookup($orderNumber: String!, $contactDetails: String!) {
    orderLookup(orderNumber: $orderNumber, contactDetails: $contactDetails) {
      ...OrderFields
    }
  }

  ${OrderFragment}
`;

export type OrderLookupQueryResult = {
  orderLookup: Order;
};
